import React from 'react';

import {ActionPanelContainer} from './styles';

const ActionPanel = (props) => {
    return (
        <ActionPanelContainer>
            <div className="action-panel" style={props?.style}>
                {props.children}
            </div>
        </ActionPanelContainer>
    );
};

export default ActionPanel;
